import { render, staticRenderFns } from "./ComputadoraABM.vue?vue&type=template&id=332d83e6&"
import script from "./ComputadoraABM.vue?vue&type=script&lang=js&"
export * from "./ComputadoraABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports